/**
 * LegalPage - 法律文档页（服务条款 / 隐私政策）通用布局。
 *
 * 复用同一布局，通过 i18nKey 区分内容（"legal.terms" / "legal.privacy"）。
 * navbar/footer 由 PublicLayout 提供。
 *
 * 法律文档与 blog/guides 一样仅英文（不维护翻译，避免多语法律文本的维护与
 * 合规偏差）：非 en 访问由 EnglishOnlyRoute 重定向到 /en 同路径，
 * 内容只存在于 en.json 的 legal 命名空间。
 */

import { useTranslation } from "react-i18next";
import EnglishOnlyRoute from "../components/EnglishOnlyRoute";
import PublicLayout from "../components/PublicLayout";
import { LocalizedLink } from "../lib/lang";

interface Section {
  heading: string;
  body: string;
}

export default function LegalPage({ i18nKey }: { i18nKey: "legal.terms" | "legal.privacy" | "legal.aup" }) {
  const { t } = useTranslation();
  // i18next 对数组返回值：用 returnObjects 拿到 sections 数组
  const sections = t(`${i18nKey}.sections`, { returnObjects: true }) as Section[];
  const today = new Date().toLocaleDateString();

  return (
    <EnglishOnlyRoute>
      <div className="legal-page">
        <PublicLayout>
          <article className="legal-content">
            <h1>{t(`${i18nKey}.title`)}</h1>
            <p className="legal-updated">{t("legal.lastUpdated", { date: today })}</p>
            <p className="legal-intro">{t(`${i18nKey}.intro`)}</p>

            {Array.isArray(sections) &&
              sections.map((s, i) => (
                <section key={i} className="legal-section">
                  <h2>{s.heading}</h2>
                  <p>{s.body}</p>
                </section>
              ))}

            <LocalizedLink to="/" className="link-btn legal-back">
              {t("legal.backHome")}
            </LocalizedLink>
          </article>
        </PublicLayout>
      </div>
    </EnglishOnlyRoute>
  );
}
